import React, { Component } from "react";
import Desplegable from "../../desplegable";
import VistaFormacionReligiosa from "../../hermana/vistas/vista_formacion_religiosa";
import FormFormacionReligiosa from "../formularios/form_formacion_religiosa";

export default class DesplegableFormacionReligiosa extends Component {
  render() {
    return (
      <Desplegable
        eventKey="17"
        id="17"
        handleButtonShow={this.props.handleButtonShow}
        showModal={this.props.state.showModalMatrix[17]}
        boton="Añadir"
        Toogle={"Formación Etapa Vida Religiosa"}
        Text={
          <VistaFormacionReligiosa
            DatosMonja={this.props.state.DatosUsuario}
            showModalFormacionReligiosa={this.props.state.showModalMatrix[18]}
            handleButtonShow={this.props.handleButtonShow}
            setFormacionReligiosa={this.props.setFormacionReligiosa}
            putFormacionReligiosa={this.props.putFormacionReligiosa}
            deleteFormacionReligiosa={this.props.deleteFormacionReligiosa}
            ErrorHandling={this.props.ErrorHandling}
            canEdit={this.props.esAdmin}
            setAlert={this.props.setAlert}
          ></VistaFormacionReligiosa>
        }
        Form={
          <FormFormacionReligiosa
            DatosMonja={this.props.state.DatosUsuario}
            handleButtonShow={this.props.handleButtonShow}
            setFormacionReligiosa={this.props.setFormacionReligiosa}
            putFormacionReligiosa={this.props.putFormacionReligiosa}
            setAlert={this.props.setAlert}
            ErrorHandling={this.props.ErrorHandling}
          ></FormFormacionReligiosa>
        }
        canEdit={this.props.esAdmin}
      />
    );
  }
}
